import { render, staticRenderFns } from "./AlumnosDetailRow.vue?vue&type=template&id=5d6dc176&"
import script from "./AlumnosDetailRow.vue?vue&type=script&lang=js&"
export * from "./AlumnosDetailRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports